// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const {
    recordProcess,
    PROC_END,
    PROC_FAIL,
    PROC_RA_REFUND,
} = require('utilities/tagging');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const raErrorHandlerActions = require('./RAErrorHandler');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { RA_REIMBURSEMENT } = require('utilities/tagging');

const reset = () => ({
    type: actionTypes.RA_REIMBURSEMENT_REQUEST_RESET,
});

const reimbursementRequestSuccess = () => ({
    type: actionTypes.RA_REIMBURSEMENT_REQUEST_SUCCESS,
});

const reimbursementRequestInProgress = () => ({
    type: actionTypes.RA_REIMBURSEMENT_REQUEST_IN_PROGRESS,
});

const reimbursementRequestFailure = error => ({
    type: actionTypes.RA_REIMBURSEMENT_REQUEST_FAILURE,
    payload: {
        error,
    },
});

const setReimbursementRequestAmount = amount => ({
    type: actionTypes.RA_REIMBURSEMENT_REQUEST_SET_REIMBURSEMENT_AMOUNT,
    payload: amount,
});

const reimbursePlan = (portfolioId, dataToken, history) => (
    dispatch,
    getState,
) => {
    const immReimbursementRequest = getState().raReimbursement;
    const immGlobalPosition = getState().raGlobalPosition;
    const immPortfolio = immGlobalPosition.getIn(['portfolios', portfolioId]);
    const amount = immReimbursementRequest.getIn([
        'reimbursementDetails',
        'amount',
    ]);
    const params = {
        portfolioId,
    };
    const requestData = {
        query: {
            amount,
            dataToken,
        },
    };

    const customData = {
        processDetail: 'robo cartera ' + immPortfolio.get('name'),
    };

    dispatch(reimbursementRequestInProgress());

    taggingEventHandled(RA_REIMBURSEMENT, 'consultOTPSuccess', {
        productName: customData.processDetail,
        amount,
    });

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raDoWithdrawWithPortfolioId', params),
        requestData,
    )
        .then(() => {
            dispatch(reimbursementRequestSuccess());
            dispatch(outdateMyInvestments());

            recordProcess(PROC_RA_REFUND, PROC_END, customData);
        })
        .catch(error => {
            if (error.error) {
                dispatch(reimbursementRequestFailure(error.error.description));
            } else {
                throw error;
            }

            dispatch(raErrorHandlerActions.show(error, history));
            window &&
                window.utag &&
                window.utag.view &&
                window.utag.view({ amount });
            recordProcess(PROC_RA_REFUND, PROC_FAIL, customData);
        });
};

const finish = (history, portfolioId) => (dispatch, getState) => {
    const reimbursePlanCallback = (dispatch, _, dataToken) => {
        dispatch(reimbursePlan(portfolioId, dataToken, history));
    };

    dispatch(reimbursementRequestInProgress());
    signaturePatternActions.validateAndExecute(
        dispatch,
        getState,
        reimbursePlanCallback,
    );
};

module.exports = {
    reimbursePlan,
    reset,
    finish,
    setReimbursementRequestAmount,
};
